import clsx from 'clsx';

import { Message } from '@/services/types/artifact-types';

import { AttachmentList } from './AttachmentList';

interface MessageDetailsProps {
  message: Message;
  isEmail: boolean;
  isVisible: boolean;
}

export const MessageDetails = ({
  message,
  isEmail,
  isVisible,
}: MessageDetailsProps) => {
  if (!isVisible) return null;

  const hasAttachments = message.attachments && message.attachments.length > 0;
  const hasSource = message.source || message.source_timestamp;

  return (
    <div
      className={clsx(
        'mt-4 pt-4 border-t border-gray-200 space-y-4',
        'animate-in slide-in-from-top-2 duration-200 ease-out',
        isEmail ? 'ml-8' : '',
      )}
    >
      {/* Attachments Section */}
      {hasAttachments && (
        <AttachmentList attachments={message.attachments || []} isExpanded />
      )}

      {/* Source Information */}
      {hasSource && (
        <div>
          <h4 className="text-xs font-semibold text-gray-700 mb-2 uppercase tracking-wide">
            Source
          </h4>
          <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
            <div className="space-y-1">
              {message.source && (
                <div className="font-medium text-sm text-gray-900">
                  {message.source}
                </div>
              )}
              {message.source_timestamp && (
                <div className="text-xs text-gray-500">
                  {new Date(message.source_timestamp).toLocaleString()}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
